/* global process */
let base = window._env_.VUE_APP_ADMIN_HOST + '/clb'
export const getClbStepTemplateTable = params => {
  return axios.post(`${base}/query_substep`, params)
}
export const getClbStepTemplateDetail = params => {
  return axios.get(`${base}/get_substep_${params.id}`, {params})
}
export const exportClbStepTemplateData = params => {
  return axios.get(`${base}/exportClbStepTemplateData/${params.id}`, {params})
}
export const createClbStepTemplateData = params => {
  return axios.post(`${base}/create_substep`, params)
}
export const updateClbStepTemplateData = params => {
  return axios.post(`${base}/modify_substep_${params.id}`, params)
}
export const deleteClbStepTemplateData = params => {
  return axios.post(`${base}/delete_substep_${params.id}`, params)
}



// WEBPACK FOOTER //
// ./src/views/clb-step-template/clb-step-template.api.js